import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';
import { BillingGroup } from '../../api/types/billing-group';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useBillingGroups = ({ page, perPage }: { page: number; perPage: number }) => {
  return useQuery<PaginatedResponse<BillingGroup>, ApiError>({
    queryKey: billingGroupsKeys.list(page, perPage),
    queryFn: () => billingGroupApi.fetchBillingGroups(page, perPage),
  });
};
